export default __webpack_public_path__ + "static/media/nothing-here-dark.c3cb25fb.png";